import { OVERLAYS } from "@coeff/utils";
import styled from "styled-components";

export const DisabledOverlay = styled.div<React.HTMLAttributes<HTMLDivElement>>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: white;
  opacity: ${OVERLAYS.dimOpacity};
  z-index: 100;
  overflow: hidden;

  &.dark {
    background-color: ${OVERLAYS.dim};
  }
`;
